export const formIsValid = (context) => {
  let isValid = true;
  const values = Object.values(context.$refs);
  for (let i = 0; i < values.length; i++) {
    if (!values[i]?.hasOwnProperty("isInvalid")) continue;
    if (values[i].isInvalid()) isValid = false;
  }
  return isValid;
};
